// Datos de los planes que comparten la landing, el panel y el catálogo público.
// PRO_PRICE tiene que coincidir con transaction_amount en n8n/miqrapp-suscripciones.js.
export const FREE_PRODUCT_LIMIT = 12;
export const PRO_PRICE = "$ 7.999";
export const PRO_TRIAL_DAYS = 30;
// Si es true, el carrito con pedidos por WhatsApp es solo para Pro (aunque el dueño lo active).
export const ORDERS_PRO_ONLY = false;
// Si es true, cobrar el carrito con Mercado Pago es solo para Pro. Tiene que coincidir
// con SOLO_PRO de n8n/miqrapp-cobros-mp.js.
export const MP_PRO_ONLY = true;
// Funciones del plan Pro que en Gratis se ven bloqueadas con la invitación a probar Pro.
// Si alguna pasa a ser para todos, alcanza con poner false.
// Logo del negocio y color del menú en el QR y el cartel (para todos los planes).
export const QR_STYLE_PRO_ONLY = false;
// Banner de promociones arriba del menú.
export const PROMOS_PRO_ONLY = true;
// Más de una foto por producto (en Gratis, una sola).
export const GALLERY_PRO_ONLY = true;
